<template>
    <b-overlay :show="loading">
      <div class="users-style">

        <h4 class="mt-3 mb-2">Carrying Data</h4>
        <p style="font-size: 15px;">Download the template, insert the data in the sheet and import the historical data.</p>

        <ul class="list-group my-3" v-if="errormsg.length > 0">
          <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
          <li class="list-group-item list-group-item-success" >Success : All other inputs have been imported successfully!</li>
        </ul>


        <div class="clearfix row py-2 mb-2 no-margin">
          <div class="col-sm-6 pl-0">
            <div class="custom-search">
              <b-input-group class="mb-0">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
              </b-input-group>


            </div>
          </div>
          <div class=" col-sm-6 text-right pr-0">
            <b-button @click="downloadTemplate"><b-icon icon="code-slash" ></b-icon> Template </b-button>
            <b-button @click="$bvModal.show('bv-modal-import-carry');"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import </b-button>
          </div>

        </div>
        <div class="row justify-content-center no-margin">
          <table class="table dataTable">
            <thead>
            <tr class="table-head">
              <th class="cursor-pointer" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"><span>{{column.label}}</span></th>

            </tr>
            </thead>
            <tbody>
            <tr class="hover-bg table-row mx-2" v-for="user in paginatedData" :key="user.id">
              <td>{{user.name}}</td>
              <td>{{user.employee_code}}</td>
              <td>{{user.carry_string}}</td>
            </tr>
            </tbody>
          </table>

          <div v-if="paginatedData.length == 0" class="list-no-data">{{ blankmsg }}</div>
          <div v-if="paginatedData.length > 0" class="px-3 mt-4 w-100">
            <ul class="pagination b-pagination float-left mb-0 mt-1">
              <li class="page-item disabled m-2">View</li>
              <li class="page-item disabled">
                <b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select>
              </li>
              <li class="page-item disabled m-2">per page. Total {{carrying_data.length}} records found.</li>
            </ul>
            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
          </div>


        </div>

        <b-modal id="bv-modal-import-carry" size="md" title="Import Carrying Data" @cancel="$bvModal.hide('bv-modal-import-carry')" @ok="uploadCarryFile" ok-title="Upload" footerClass="d-flex flex-row justify-content-center border-0">
          <div class="row clearfix mb-2"><div class="col-md-12">Click browse and upload file</div></div>
          <b-form-file @change="getFile" id="carryfile" name="carryfile" accept=".xlsx,.xls"></b-form-file>
        </b-modal>

      </div>
    </b-overlay>
</template>


<script>
    export default{

        mounted() {
        },
        data(){
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Employee Code', name: 'employee_code'},
                            {label: 'Days Carried Forward', name: 'carry_string'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {


                columns: columns,
                sortKey: 'name',
              loading: false,
                sortOrders: sortOrders,

                search:'',

                blankmsg : 'Fetching data..',

                carrying_data:[],

                length: 20,
                temp_length: 20,
                length_options: [
                  { value: 20, text: "20" },
                  { value: 50, text: "50" },
                  { value: 100, text: "100" },
                  { value: 500, text: "500" },
                  { value: 1500, text: "1500" },
                ],
                pagination: {currentPage: 1, total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                errormsg : {},
            }
        },

        created: function(){
            this.getCarryingData();
        },
        methods:{
          getFile(event) {
            this.empfile = event.target.files[0];
          },
          downloadTemplate(){
            if (!this.checkNet()) return;
            this.showoverlay = true;
            axios.get(this.$api_url + '/leave-attendance/carry/template?flag=1', {params:{f:1},responseType: 'blob'}).then(response => {
              this.global_download_file_content(response);
              this.showoverlay = false;
            }).catch(e => this.serverError(e));
          },
            getCarryingData: function()
            {
                this.loading = true;
                if(!this.checkNet()) return false;

                this.$bvModal.hide('bv-modal-leave-details');
                let currentObj = this;
                axios.get(this.$api_url + '/leave-attendance/carrying-data' , {
                    params: {

                    }
                }).then(function(response){
                    this.loading = false;

                    this.carrying_data = response.data;

                    if(this.carrying_data.length == 0)
                        this.blankmsg = "No records found.";

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            uploadCarryFile:function(event)
            {
                if(!this.checkNet()) return false;
                this.loading = true;
                this.errormsg = {};

                let currentObj = this;

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.$api_url+'/leave-attendance/carry/import', data , config).
                    then(function (response)
                    {
                        this.$bvToast.toast('Successfully Completed', {
                                            title: `Success`,
                                            variant: 'info',
                                            solid: true
                                        });

                        this.loading = false;

                        this.$bvModal.hide('bv-modal-import-carry');
                        this.getCarryingData();


                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                    this.loading = false;
            },
            setFirstPage() {
              this.pagination.currentPage = 1;
              this.length = this.temp_length;
            },
        },
        computed:
        {

            filteredData()
            {
                let filtered_list = this.carrying_data;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
